import React from 'react'

import { Portlet, Button, Table, Row, Col } from '_zari/core'

import NuevoContactoModal from './modals/nuevo'
import EditarContactoModal from './modals/editar'

const ContactosSection = ({ contactos, dispatch }) => {
  const editarData = React.useRef({})

  const [mostrarNuevoContactoModal, setMostrarNuevoContactoModal] = React.useState(false)

  const [mostrarEditarContactoModal, setMostrarEditarContactoModal] = React.useState(false)

  const agregarContactoHandler = payload => {
    
    dispatch({ type: 'agregar', payload })
    setMostrarNuevoContactoModal(false)
  }

  const actualizarContactoHandler = payload => {
    dispatch({ type: 'actualizar', payload })
    setMostrarEditarContactoModal(false)
  }

  const editarContactoClickHandler = ({ _idFila }) => {
    const filas = contactos.filter(row => row._idFila === _idFila)
    editarData.current = filas[0]
    setMostrarEditarContactoModal(true)
  }

  const eliminarContactoHandler = ({ _idFila }) => {
    dispatch({ type: 'eliminar', payload: { _idFila } })
  }

  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={12} className='mb-2 text-right'>
              <Button onClick={e => setMostrarNuevoContactoModal(true)}>Nuevo</Button>
            </Col>
          </Row>
          <Table.ClientSide
            headRows={[
              { label: 'NOMBRE' },
              { label: 'TELÉFONO' },
              { label: 'EMAIL' },
              { label: '' }
            ]}
            filas={contactos}
            rowTemplate={row => (
              <Table.Row hover key={row._idFila}>
                <Table.Cell>{row.nombre || '--'}</Table.Cell>
                <Table.Cell>{row.telefono1 || '--'}</Table.Cell>
                <Table.Cell>{row.email1 || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => editarContactoClickHandler({ _idFila: row._idFila })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => eliminarContactoHandler({ _idFila: row._idFila })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoContactoModal && (
        <NuevoContactoModal
          handleClose={e => setMostrarNuevoContactoModal(false)}
          show={mostrarNuevoContactoModal}
          agregarContacto={agregarContactoHandler}
        />
      )}
      {mostrarEditarContactoModal && (
        <EditarContactoModal
          modalData={editarData.current}
          handleClose={e => setMostrarEditarContactoModal(false)}
          show={mostrarEditarContactoModal}
          actualizarContacto={actualizarContactoHandler}
        />
      )}
    </>
  )
}

export default React.memo(ContactosSection)
